module.exports = __webpack_public_path__ + "static/media/PHCT03.aadc318d.jpg";